import logo from "../../../assets/images/logo.svg";
import bottomImg from '../../../assets/images/Landing/bottom.png';
import { Register } from "../Dialogs/Register"

export default function ReadyToTry() {
    return (
        <div className="flex relative sm:-ml-4 sm:-mr-4  max-w-screen">
            <div className="px-2 lg:px-32 py-20 text-white w-full">
            <img src={bottomImg} className=" absolute left-0 bottom-8 h-80 z-[-1] blur-sm w-full  md:translate-y-10" />
                <div className="flex flex-col lg:flex-row lg:justify-between gap-2 items-center">
                    <div className="flex flex-col gap-4 text-center">
                        <div className="flex flex-col lg:flex-row items-center text-center gap-2">
                            <img src={logo} alt="logo" className="w-20 h-20 lg:w-10 lg:h-10" />
                            <h1 className="text-4xl font-semibold">Ready to try Teamly?</h1>
                        </div>
                        <p className="text-lg">Join to best tournament app for your team.</p>
                    </div>
                    <Register>
                        <button className="bg-gradient-to-br bg-brand-green from-brand-green to-green-600 text-white font-semibold px-6 py-2 rounded-lg transition duration-300 hover:scale-105">Get Started</button>
                    </Register>
                </div>
            </div>
        </div>
    );
}
